<template>
  <v-container>
    <v-layout class="hidden-print-only">
      <v-flex xs12 class="text-xs-right">
        <v-btn color="blue-grey lighten-4" @click="print">
          Print Receipt
          <v-icon right>print</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex class="header">
        <h2>
          Receipt {{receipt.id}}
          <small>
            Your payment of {{currency(receipt.totalPayment)}}
            was received on {{dotDate(receipt.paymentDate)}}.
          </small>
        </h2>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Mixins } from '@homegauge/vue';

const { CurrencyFilter, DateTime } = Mixins;

export default {
  mixins: [DateTime, CurrencyFilter],
  props: {
    receipt: {
      required: true,
      type: Object,
    },
  },
  methods: {
    print() {
      window.print();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/vars/theme';
@import '../../../styles/vars/typography';

.header {
  text-align: center;
}

h2 {
  font-size: 2.2rem;
  font-weight: $typography-weight-normal;
  text-transform: none;

  small {
    color: lighten($theme-color-gray, 19.22);
    display: block;
    font-size: 1.25rem;
    padding-top: 20px;
  }
}
</style>
